export const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const progressBar = entry.target as HTMLDivElement;
          progressBar.style.width = `${progressBar.getAttribute('aria-valuenow')}%`;
        }
      });
    },
    { threshold: 0.1 } // Adjust threshold as needed
  );